export function toCapitalCaseSafe(input?: string | null): string {
  if (!input) return "";
  return input
    .trim()
    .toLowerCase()
    .split(/\s+/)
    .map(w => w[0]?.toUpperCase() + w.slice(1))
    .join(" ");
}

export function formatMoneyVN(value: string | number | undefined): string {
  if (value === null || value === undefined) return "";

  const numeric = value
    .toString()
    .replace(/\D/g, ""); // chỉ giữ số

  if (!numeric) return "";

  return numeric.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
}

export function formatScore(value: string | number): string {
  if (value === null || value === undefined || value === "") return "";

  const num = Number(value);

  if (Number.isNaN(num)) return "";

  return num.toFixed(2);
}

export function getLocalDate(value: string): Date {
  const localDate = new Date(value);
  localDate.setMinutes(localDate.getMinutes() - localDate.getTimezoneOffset());
  return localDate;
}

export async function preCheckExistWrapper<T>(currentValue: T | undefined, newValue: T, checkExistCallback: (value: T) => Promise<void>) {

  if (!currentValue?.toString().trim() && newValue?.toString().trim()) {
    // Trường hợp tạo mới
    await checkExistCallback(newValue);
  } else {
    if (!newValue) return
    // Trường hợp cập nhật
    if (newValue && currentValue?.toString().trim() == newValue?.toString().trim()) {
      // Giá trị không đổi, bỏ qua check API
      return;
    }
    await checkExistCallback(newValue);
  }
}